<template>
  <div
    id="maintenance"
    class="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center center"
  >
    <a href="/"
      >The website is temporarily offline for maintenance. Please try again
      shortly.</a
    >
  </div>
</template>

<script>
export default {};
</script>

<style lang="css" scoped>
@import "../css/variables";

#maintenance {
  z-index: 9999;
  background: var(--red);
  color: var(--col-light);
}

a {
  color: var(--col-light);
}
</style>
